"use client";

import React from "react";
import { HVFlex, HVIcon, HVLogo, HVText } from "../..";
import styles from "./HVAppsMenu.module.css";
import IHVAppsMenuProps from "./IHVAppsMenuProps";
import IHVLogoProps from "../HVLogo/IHVLogoProps";

function HVAppsMenu({
  appsMenuContainerProps,
  apps,
  helpSection,
  helpText,
  onHelpClick,
  logoContainerProps,
  subLogoContainerProps,
  helpContainerProps,
  helpSectionIconProps,
  helpTextProps,
  subHelpContainerProps,
  subHelpSectionIconProps
}: IHVAppsMenuProps) {
  return (
    <HVFlex
      className={styles.appsMenuContainer}
      direction={"row"}
      wrap={"wrap"}
      {...appsMenuContainerProps}
    >
      <HVFlex  {...logoContainerProps} className={styles.logoContainer}>
        {apps.map((app: IHVLogoProps) => (
          <HVFlex  {...subLogoContainerProps} key={app.text}>
            <HVLogo {...app} />
          </HVFlex>
        ))}
      </HVFlex>
      {helpSection && (
        <HVFlex
        {...helpContainerProps}
          className={styles.helpContainer}
          direction={"row"}
          onClick={onHelpClick}
        >
          <HVIcon
          {...helpSectionIconProps}
            name="help"
            svgProps={{ width: 24, stroke: "var(--hv-icon-normal-secondary)" }}
          />
          <HVText {...helpTextProps}>{helpText || "Help"}</HVText>
          <HVFlex className={styles.rightIcon} {...subHelpContainerProps}>
            <HVIcon
             {...subHelpSectionIconProps}
              name="arrow-chevron-right"
              svgProps={{
                width: 16,
                stroke: "var(--hv-icon-normal-secondary)",
              }}
            />
          </HVFlex>
        </HVFlex>
      )}
    </HVFlex>
  );
}

export default HVAppsMenu;
